/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfFinancialMovementDto } from "../models/AjaxResponseOfFinancialMovementDto";
import type { AjaxResponseOfGetBalanceValueDtoOfFinancialMovementForView } from "../models/AjaxResponseOfGetBalanceValueDtoOfFinancialMovementForView";
import type { FinancialMovementDto } from "../models/FinancialMovementDto";
import type { MovementType } from "../models/MovementType";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class FinancialMovementAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfFinancialMovementDto
   * @throws ApiError
   */
  public getById({
    financialId,
  }: {
    financialId: string;
  }): CancelablePromise<AjaxResponseOfFinancialMovementDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/financial-movement/{financialId}",
      path: {
        financialId: financialId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGetBalanceValueDtoOfFinancialMovementForView
   * @throws ApiError
   */
  public getAll({
    filter,
    movementType,
    initialDate,
    finalDate,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    movementType?: MovementType;
    initialDate?: string;
    finalDate?: string;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfGetBalanceValueDtoOfFinancialMovementForView> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/financial-movement",
      query: {
        filter: filter,
        movementType: movementType,
        initialDate: initialDate,
        finalDate: finalDate,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: FinancialMovementDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/financial-movement",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public update({
    requestBody,
  }: {
    requestBody?: FinancialMovementDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/financial-movement",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({ id }: { id: string }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/financial-movement/{id}",
      path: {
        id: id,
      },
    });
  }
}
